import styles from './Loader.module.scss';

import cn from 'classnames';

import Spinner from './images/spinner.svg?react';

interface Props {
  isHeaderVisible?: boolean;
  isPolls?: boolean;
  inline?: boolean;
  padding?: number;
  paddingBottom?: number;
  screenStyles?: object;
  inButton?: boolean;
}
export const Loader = ({
  isHeaderVisible = false,
  inline = false,
  padding,
  paddingBottom,
  screenStyles = {},
  inButton = false,
}: Props) => {
  const componentStyles = {} as any;
  if (padding) componentStyles.padding = `${padding}px 0`;
  if (paddingBottom) componentStyles.paddingBottom = `${paddingBottom}px`;

  if (inline) {
    return (
      <div style={componentStyles}>
        <Spinner className={styles.spinner} />
      </div>
    );
  }

  if (inButton) {
    return (
      <div className={styles.inButton}>
        <Spinner className={styles.spinner} />
      </div>
    );
  }

  return (
    <div
      style={screenStyles}
      className={cn(
        styles.loaderScreen,
        isHeaderVisible && styles.visibleHeader,
      )}
    >
      <Spinner className={styles.spinner} />
    </div>
  );
};
